// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"loading-spinner__loading-spinner__hP6NJ","spinnerContainer":"loading-spinner__spinner-container__hjQ0L","textContainer":"loading-spinner__text-container__gzQ0n"};